import React from 'react';
import toast from 'react-hot-toast';
import { useLanguage } from '../../../../base/LanguageProvider';
import { getFullName } from '../../../../data/user/user';
import { useRemoveUser, useUser } from '../../../../data/user/userActions';
import Manager from '../../../../shared/modal/Manager';
import Modal from '../../../../shared/modal/Modal';
import ModalFooter from '../../../../shared/modal/ModalFooter';
import ModalHeader from '../../../../shared/modal/ModalHeader';
import { ModalBody } from '../../../../styled/Modal';
function DeleteUserModal(props) {
    var _a, _b;
    var L = useLanguage().L;
    var user = useUser(props.userId);
    var removeUser = useRemoveUser();
    function submitHandler() {
        removeUser.mutate(props.userId, {
            onSuccess: function () {
                toast.success(L('User has been removed'));
                Manager.closeModal();
            },
            onError: function () {
                toast.error(L('Failed to remove user'));
            },
        });
    }
    var fullName = ((_a = user.data) === null || _a === void 0 ? void 0 : _a.keycloakId) ? getFullName(user.data) : (_b = user.data) === null || _b === void 0 ? void 0 : _b.firstName;
    return (React.createElement(Modal, { width: "400", height: "300" },
        React.createElement(ModalHeader, { title: L('Deleting user') + ' ' + fullName }),
        React.createElement(ModalBody, null, L('Are you sure you want to delete user') + ' ' + fullName + '?'),
        React.createElement(ModalFooter, { loading: removeUser.isLoading || !user.data, done: submitHandler, doneColor: "error", doneLabel: L('Delete') })));
}
export default DeleteUserModal;
